import pipelineSvg from "../assets/generated/pipeline.svg?raw";

export function HomeOpsVisual() {
  return (
    <div className="hero-ops-visual" aria-hidden>
      <div
        className="hero-pipeline-frame"
        dangerouslySetInnerHTML={{ __html: pipelineSvg }}
      />
      <ul className="hero-ops-readout">
        <li>
          <span className="hero-ops-dot" />
          <span className="hero-ops-label">Covers</span>
          <span className="hero-ops-value">apps, cloud, devices</span>
        </li>
        <li>
          <span className="hero-ops-dot" />
          <span className="hero-ops-label">Bad builds</span>
          <span className="hero-ops-value">stop at the gate</span>
        </li>
        <li>
          <span className="hero-ops-dot" />
          <span className="hero-ops-label">Artifacts</span>
          <span className="hero-ops-value">kept with the release</span>
        </li>
      </ul>
    </div>
  );
}
